import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-table-icons_Electricity",
  "use": "svg-icon-table-icons_Electricity-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"svg-icon-table-icons_Electricity\"><path d=\"M15.306 9.538h-2.77V3.695c0-.654-.823-.945-1.234-.437l-5.646 6.975a.694.694 0 00.54 1.13h2.77v5.845c0 .653.82.944 1.23.437l5.65-6.98a.693.693 0 00-.54-1.127\" fill=\"#FFCB30\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol